<template>
  <div class="content">
    <p><mp-simple-spinner size="20" /></p>
  </div>
</template>

<script>
import { Authentication } from "@/Kernel/Authentication";

export default {
  name: "AuthLoginController",
  computed: {
    isLoggedIn() {
      return this.$store.getters["Account/isLoggedIn"];
    }
  },
  watch: {
    isLoggedIn() {
      this.postLogin();
    }
  },
  created() {
    if (this.isLoggedIn) {
      this.postLogin();
    } else {
      this.login();
    }
  },
  methods: {
    postLogin() {
      this.$router.push({ name: "root" });
    },
    login() {
      Authentication.login()
        .then(() => {
          this.$store.dispatch("Account/login");
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
.content {
  text-align: center;
}
</style>
